/* eslint-disable */
// @ts-nocheck

import React from "react";
import { Tile, SkeletonText } from "@carbon/react";
import { ReactComponent as DoubleArrow } from "../../assets/icons/right-left-arrow.svg";
import { ReactComponent as Organisation } from "../../assets/icons/organisation.svg";

export enum Icons {
  Locations,
  Organisations,
  Mappings,
}

const getIconFromName = (IconName: Icons) => {
  switch (IconName) {
    case Icons.Mappings:
      return <DoubleArrow />;
    case Icons.Organisations:
      return <Organisation />;
    case Icons.Locations:
      return <Organisation />;
    default:
      return null;
  }
};

interface IProps {
  total: string;
  label: string;
  icon: any;
  loading?: boolean;
}

const SmallTiles = ({ total, label, icon, loading }: IProps) => {
  return (
    <Tile className="small-tiles">
      <div className="small-tiles-body">
        {loading ? (
          <SkeletonText heading={true} width={"70%"} />
        ) : (
          <p className="small-tiles-heading">{total}</p>
        )}
        <div className="small-tiles-textbox">
          {getIconFromName(icon)}
          <p className="small-tiles-text">{label}</p>
        </div>
      </div>
    </Tile>
  );
};

export default SmallTiles;
